<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="companies"
      :search="search"
      :page.sync="currentPage"
      group-by="smsapi"
      class="transparent"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:group.header="{group,headers,isOpen,toggle}">
        <td :colspan="headers.length">
          <v-btn icon @click="toggle">
            <v-icon>{{isOpen?'mdi-minus':'mdi-plus'}}</v-icon>
          </v-btn>
          {{$store.getters['admin/smsapi'](group).name}}
        </td>
      </template>
      <template v-slot:top>
        <v-btn fab absolute bottom @click="edit({})" dark class="pink">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-btn icon @click="edit(item)">
          <v-icon color="primary">mdi-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.status="{item}">{{$t("status.rec_"+item.status)}}</template>
      <template v-slot:item.created="{item}">{{item.created | dt-time}}</template>
      <template v-slot:item.debit="{item}">{{item.debit | currency}}</template>
      <template v-slot:item.tarif="{item}">{{(item.settings?item.settings.tarif:"0") | currency4}}</template>
      <template
        v-slot:item.limit="{item}"
      >{{(item.settings?item.settings.limit*100:"0") | currency}}</template>
      <template v-slot:item.updated="{item}">{{item.updated | dt-time}}</template>
      <template v-slot:item.smsapi="{item}">{{$store.getters["admin/smsapi"](item.smsapi).name}}</template>
    </v-data-table>
    <v-dialog v-model="d_edit" persistent width="700">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <span>{{$t("admin.company")}}</span>
          <v-spacer></v-spacer>
          <v-btn @click="d_edit=false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field v-model="item.name" :label="$t('fields.name')"></v-text-field>
            <v-select v-model="item.status" :items="$t('recStatus')" :label="$t('fields.status')"></v-select>
            <v-select
              v-model="item.smsapi"
              :items="$store.getters['admin/smsapies']"
              item-text="name"
              item-value="idx"
              :label="$t('fields.smsapi')"
            ></v-select>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="item.settings.limit"
                  class="right-input mr-2"
                  suffix="€"
                  :label="$t('fields.limit')"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="item.settings.tarif"
                  class="right-input mr-2"
                  :suffix="$t('fields.tarifsuf')"
                  :messages="tarif2euro"
                  :label="$t('fields.tarif')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-text-field v-model="item.settings.sender" :label="$t('fields.sender')"></v-text-field>
            <v-row align="center">
              <v-col cols="3">{{$t('fields.debit')}}</v-col>
              <v-col class="title" cols="2">{{item.debit|currency}}</v-col>
              <v-col>
                <v-text-field v-model="comment2add"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="money2add"
                  suffix="€"
                  class="right-input mr-2"
                  :error-messages="add_err"
                  @keyup.enter="add2acc"
                  @change="add_err=''"
                >
                  <template v-slot:append-outer>
                    <v-icon large color="success" @click="add2acc">mdi-plus-circle-outline</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- <v-text-field disabled v-model="item.debit" :messages="debit2euro" :label=""></v-text-field> -->
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="dmode='delete', d_confirm=true"
            color="primary"
          >{{$t("button.delete")}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="update" color="primary">{{$t("button.update")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      v-model="d_confirm"
      :mode="dmode"
      @click:ok="confirmed"
    >{{$t("dialog.txt.delCompany")}}</ConfirmDialog>
  </div>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";

export default {
  name: "Companies",
  mixins: [commonmixin],
  data() {
    return {
      d_edit: false,
      add_err: "",
      money2add: "",
      comment2add: "Iemaksa",
      item: { settings: {}, debit: 0 },
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          width: 100,
          sortable: false
        },
        {
          text: this.$t("fields.name"),
          value: "name"
        },
        {
          text: this.$t("fields.debit"),
          value: "debit",
          align: "right",
          width: 120
        },
        {
          text: this.$t("fields.tarif"),
          value: "tarif",
          width: 90
        },
        {
          text: this.$t("fields.limit"),
          value: "limit",
          width: 120
        },
        {
          text: this.$t("fields.sender"),
          value: "settings.sender"
        },
        {
          text: this.$t("fields.smsapi"),
          value: "smsapi"
        },
        {
          text: this.$t("fields.created"),
          value: "created"
        },
        {
          text: this.$t("fields.updated"),
          value: "updated"
        },
        {
          text: this.$t("fields.status"),
          value: "status"
        }
      ]
    };
  },
  methods: {
    async add2acc() {
      if (!this.money2add) return;
      try {
        const m = this.money2add.split(",").join(".") * 100;
        if (isNaN(m)) {
          this.add_err = "Wrong number";
        } else if (this.item.debit + m < 0) {
          this.add_err = "Result < 0";
        } else {
          await this.$store.dispatch("admin/ADD_TO_COMPANY", {
            editIndex: this.currentIdx,
            idx: this.item.idx,
            data: {
              add: m,
              comment: this.comment2add
            }
          });
          this.item.debit = this.$store.getters["admin/company"](
            this.item.idx
          ).debit;
        }
      } catch (e) {
        this.add_err = e.message;
      }
      this.money2add = "";
    },
    confirmed() {
      switch (this.dmode) {
        case "delete":
          this.remove();
          break;
      }
    },
    edit(i) {
      this.d_edit = true;
      this.item = { ...i };
      if (!this.item.settings) {
        this.item.settings = { sender: "", tarif: "", limit: "" };
      }
      this.currentIdx = this.companies.indexOf(i);
    },
    remove() {
      this.$store.dispatch("admin/DELETE_COMPANY", this.item).then(() => {
        this.d_edit = false;
      });
    },
    update() {
      if (this.item.idx) {
        this.$store
          .dispatch("admin/UPDATE_COMPANY", {
            item: this.item,
            index: this.currentIdx
          })
          .then(() => {
            this.d_edit = false;
          });
      } else {
        this.$store.dispatch("admin/INSERT_COMPANY", this.item).then(() => {
          this.d_edit = false;
        });
      }
    }
  },
  computed: {
    debit2euro() {
      return this.$options.filters["currency"](this.item.debit);
    },
    tarif2euro() {
      return this.$options.filters["currency4"](this.item.settings.tarif);
    },
    companies() {
      return this.$store.getters["admin/companies"];
    }
  },
  mounted() {
    if (!this.$store.getters["admin/isSmsapies"]) {
      this.$store.dispatch("admin/LOAD_SMSAPIES");
    }
    if (!this.$store.getters["admin/isCompanies"]) {
      this.$store.dispatch("admin/LOAD_COMPANIES");
    }
  }
};
</script>

<style scoped>
.right-input >>> input {
  text-align: right;
}
</style>